import type { ChangeEvent } from 'react';

import EmailOutlined from '@mui/icons-material/EmailOutlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import { Box, DialogContent, Divider, TextField, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';

const ShareDialogContent = ({
  header,
  shareUrl,
  onCopyClick,
  emailError,
  recipient,
  handleChangeRecipient,
  onSendEmail,
  content,
  onContentChange,
  enableSendEmail = true
}: {
  header: string;
  shareUrl: string;
  onCopyClick: () => void;
  emailError: string;
  recipient: string;
  handleChangeRecipient: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSendEmail: () => Promise<void>;
  content: string;
  onContentChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  enableSendEmail?: boolean;
}) => {
  return (
    <DialogContent
      sx={{ backgroundColor: 'background.default', minWidth: 540, '& p': { fontWeight: 700 } }}
    >
      <Typography variant='h5'>{header}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 3 }}>
        <LinkOutlined sx={{ mr: 1 }} />
        <Typography>Share a link</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          hiddenLabel
          sx={{
            fontSize: 14,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textWrap: 'nowrap',
            flexGrow: 1,
            '& .MuiFilledInput-input': {
              py: '14px!important'
            },
            '& .MuiInputBase-root': {
              backgroundColor: '#4F545873'
            }
          }}
          value={shareUrl}
          variant='filled'
        />
        <Button
          color='primary'
          sx={{ ml: 1, height: 48, width: 120, minWidth: 120 }}
          variant='contained'
          onClick={onCopyClick}
        >
          Copy link
        </Button>
      </Box>
      {enableSendEmail && (
        <>
          <Divider sx={{ my: 4, color: 'info.dark', fontSize: 12 }}>OR</Divider>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <EmailOutlined sx={{ mr: 1 }} />
            <Typography>Share via email</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'start', height: 70 }}>
            <TextField
              hiddenLabel
              error={!!emailError}
              helperText={emailError}
              placeholder="Enter the recipient's email..."
              sx={{
                fontSize: 14,
                flexGrow: 1,
                '& .MuiFilledInput-input': {
                  py: '14px!important'
                },
                '& .MuiInputBase-root': {
                  backgroundColor: '#4F545873'
                }
              }}
              value={recipient}
              variant='filled'
              onChange={handleChangeRecipient}
            />
            <Button
              color='primary'
              sx={{ ml: 1, height: 48, width: 120, whiteSpace: 'nowrap' }}
              variant='contained'
              onClick={onSendEmail}
            >
              Send an email
            </Button>
          </Box>
          <Typography sx={{ my: 1, fontSize: 14 }}>Message (Optional)</Typography>
          <TextField
            fullWidth
            hiddenLabel
            multiline
            maxRows={5}
            minRows={3}
            placeholder='Type your message...'
            value={content}
            variant='outlined'
            onChange={onContentChange}
          />
        </>
      )}
    </DialogContent>
  );
};
export default ShareDialogContent;
